module.exports = __webpack_public_path__ + "img/holly_bells.9aa798e3.svg";